import { useCallback, useEffect, useState } from 'react'

import { Header, PageTitle } from '@/components'
import { Card } from '@/components/ui'
import Loader from '../../../common/components/Loader'
import { Activity } from '../../../common/models'
import { IColumn, Table } from '../../../core/components/Table'
import { formatDateTime } from '../../../core/constants/times'
import { useTableParams } from '../../../core/hooks/table-params'
import { mockActivity } from './activity-mock-data'
import { MessageBox } from '../messages/MessageBox'
import { Pagination } from '../Pagination'

export const ActivityLogPage: React.FC = (): JSX.Element => {
  const { page, setPage, size, setSize, totalElements, setTotalElemenets } =
    useTableParams()

  const [activities, setActivities] = useState<Activity[]>([])
  const [isError, setIsError] = useState<boolean>(false)
  const [showMessageBox, setShowMessageBox] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const getData = useCallback(async () => {
    try {
      setLoading(true)
      // const response = await getActivityLog({
      //   page: page - 1,
      //   size,
      // })
      const response = mockActivity
      setActivities(response.data.content)
      setTotalElemenets(response.data.totalElements)
      setSize(response.data.size)
      setPage(response.data.pageNumber + 1)
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
      } else {
        console.error(e)
      }
    } finally {
      setLoading(false)
    }
  }, [page, size, setPage, setSize, setTotalElemenets])

  useEffect(() => {
    getData()
  }, [getData])

  const pageChange = async (newPage: number) => {
    setPage(newPage)
  }

  const columns: IColumn[] = [
    {
      title: 'Name',
      accessor: 'name',
    },
    {
      title: 'Date',
      accessor: 'date',
      render: (row) => <>{formatDateTime(row.date)}</>,
    },
    {
      title: 'Email',
      accessor: 'email',
    },
    {
      title: 'Description',
      accessor: 'description',
    },
  ]

  return (
    <>
      <Header pageTitle="Change Log" />
      {loading && <Loader />}
      <Card className="p-5 !bg-monochrome-4-60">
        <PageTitle title="Change Log" className="mb-5" />
        <Table columns={columns} data={activities} />
      </Card>
      <Pagination
        size={size}
        totalElements={totalElements}
        setSize={setSize}
        page={page + 1}
        changePage={pageChange}
      />
      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
      />
    </>
  )
}
